import React, { useEffect, useState } from "react";
import { get } from "aws-amplify/api";
import CustomDataGrid from "../../components/CustomDataGrid";
import { Box, Typography } from "@mui/material";

const ContentProviders = () => {
  const [contentProviders, setContentProviders] = useState([]);
  const [loading, setLoading] = useState(false);
  console.log(contentProviders, "contentProviders");
  useEffect(() => {
    const fetchContentProviders = async () => {
      try {
        setLoading(true);
        const restOperation = get({
          apiName: "restapi123",
          path: "/listAllUsers",
          options: {
            queryParams: {
              groupName: "ContentProviders",
            },
          },
        });
        const { body } = await restOperation.response;
        const response = await body.json();
        const contentProvidersAttributes = response?.map((data, index) => {
          const { Attributes = [] } = data;

          const getAttributeValue = (name) =>
            Attributes.find((attr) => attr.Name === name)?.Value || null;

          return {
            id: data?.Username,
            email: getAttributeValue("email"),
            phoneNumber: getAttributeValue("phone_number"),
            name: getAttributeValue("custom:name"),
            companyName: getAttributeValue("custom:companyName"),
            designation: getAttributeValue("custom:designation"),
          };
        });
        setContentProviders(contentProvidersAttributes);
        console.log("GET call succeeded: ", response);
      } catch (err) {
        console.log(err, "error");
      } finally {
        setLoading(false);
      }
    };

    fetchContentProviders();
  }, []);

  const columns = [
    { field: "name", headerName: "Name", flex: 1 },
    { field: "email", headerName: "Email", flex: 1 },
    { field: "phoneNumber", headerName: "Phone Number", flex: 1 },
    { field: "companyName", headerName: "Company Name", flex: 1 },
    { field: "designation", headerName: "Designation", flex: 1 },
  ];
  return (
    <div>
      ContentProviders
      <Box marginTop={2}>
        <div>
          <CustomDataGrid
            loading={loading}
            slotProps={{
              loadingOverlay: {
                variant: "linear-progress",
                noRowsVariant: "skeleton",
              },
            }}
            rows={contentProviders}
            columns={columns}
            pageSize={10}
          />
        </div>
      </Box>
    </div>
  );
};

export default ContentProviders;
